import { gql } from '@apollo/client';

export const CREATE_FIND_GROUP_MUTATION = gql`
  mutation CreateFindGroupMutation($group: FindGroupInput!) {
    createFindGroup(group: $group) {
      ... on CreateFindGroupSuccess {
        group {
          id
          createdAt
          createdBy
          name
          description
          shared
          level
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
